import { isOrgAdminUser } from "./adminRoles";
import { useAdminGate, type AdminGate } from "./useAdminGate";

export type OrganizationAdminGate = AdminGate;

/**
 * Organization admin surfaces (`/admin/...`) may render for admin or fybr_admin
 * after auth resolves.
 */
export const useOrganizationAdminGate = (): OrganizationAdminGate =>
  useAdminGate(isOrgAdminUser);
